import FamilyPage from '@/pages/FamilyPage';
import ROUTE_NAMES from '@/constants/routeNames';

export default {
    path: '/rodzina/:familyEditionId/:warehouseId',
    props: true,
    name: ROUTE_NAMES.FAMILY,
    component: FamilyPage,
    meta: {
        title: 'Wybór Rodziny - opis Rodziny - Szlachetna Paczka',
        metaTags: [
            {
                name: 'robots',
                content: 'noindex, follow'
            }
        ]
    },
    query: {
        context: true
    }
};
